import { reactive, ref } from 'vue';
import moment from 'moment';

export default {
  name: 'PurchaseDisclaimerEventComponent',
  props: {
    preview: {
      type: Object,
      required: false,
      default: null,
    },
    options: {
      type: Object,
      required: false,
      default: null,
    }
  },
  setup(props) {
    const state = reactive({
    });
    console.log(props.preview, props.options)
    const formatDate = (date) => moment(String(date)).format('MMM. D, YYYY');

    const formatPrice = (cents) => {
      const dollars = (cents / 100).toFixed(2);
      const parts = dollars.split(".");
      if (parts[1] === "00") {
        return `$${parts[0]}`;
      }
      return `$${dollars}`;
    };

    const formatProduct = (handle) => {
      const match = props.options.find((option) => option.product.handle === handle);

      if (match) {
        return `KelbyOne ${match.title} ${match.description || ''}`;
      }
      return 'Product';
    };

    const formatProductPrice = (handle) => {
      const match = props.options.find((product) => product.value === handle);

      if (match) {
        return match.price;
      }
      return '$0';
    };

    return { state, formatDate, formatPrice, formatProduct, formatProductPrice };
  },
  methods: {
  }
};